import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

function PdpSharedDetailReference({ item }) {
    const { dibsReference } = item;

    if (!dibsReference) {
        return null;
    }
    return <span data-tn="pdp-spec-reference-number">{dibsReference}</span>;
}

PdpSharedDetailReference.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailReference, {
    item: graphql`
        fragment PdpSharedDetailReference_item on Item {
            dibsReference
        }
    `,
});
